module.exports = __webpack_public_path__ + "static/img/productPartner_11_1_h5.abe51e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_11_1_h5.png
// module id = KMfZ
// module chunks = 34